var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":"","fluid":"","pa-0":""}},[_c('v-layout',[_c('v-flex',{attrs:{"shrink":""}},[_c('admin-panel-drawe')],1),_c('v-flex',[_c('v-container',{attrs:{"fluid":""}},[_vm._t("default")],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }